module.exports = __webpack_public_path__ + "img/logo.f1954d15.png";